import ResponsiveTable from "../table"


const FacilitiesClub = () => {
    const sport = {
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUyiBlA-HQHZ5y4ZAFSS1pyJg6NVAHC8DRQA&usqp=CAU",
        description: "The UNITEN Gamelan group performed live during TV3’s “Wanita Hari Ini” segment. They were also invited to perform in the “Assalamualaikum” segment on TV AlHijrah, at its main studio in Cyberjaya."
    }
    const listOfClubs = [
        "Costumes and accessories",
        "Cultural props and sets",
        "Traditional musical instruments",
        "Modern musical instruments",
        "Training room",
        "Jamming Room",
    ]
    const listOfCulturalClubs = [
        "Traditional & modern dance",
        "Gamelan music",
        "Drama and theatre",
        "Choir",
        "Combo band",
        "Short cultural courses, seminars and forums",
        "Cultural competitions",
    ]
    const table1 = {
        header: [
            "List of Club Facilities",
            "List of Cultural Club Facilities"
        ]
        ,
        content: [
            [
                <ul key="1" className="flex flex-col px-4 items-start gap-2 list-disc">
                    {
                        listOfClubs.map((bullet, index) => (
                            <li key={index} className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal ">{bullet}</li>
                        ))
                    }
                </ul>,
                <ul key="2" className="flex flex-col px-4 items-start gap-2 list-disc">
                    {
                        listOfCulturalClubs.map((bullet, index) => (
                            <li key={index} className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal ">{bullet}</li>
                        ))
                    }
                </ul>,
            ]
        ]
    }
    const bookingProcedure = [
        "Check for availability of items/rooms at USK counter",
        "Make official application using forms available at USK counter",
        "Get approval from Cultural Officer",
        "For Jamming room or any rental items, make payment and keep official receipt for reference",
        "Take care of facilities or rental items used. You are responsible for any damages or loss.",
    ]
    const table2 = {
        header: [
            "Booking Procedure",
        ]
        ,
        content: [
            [
                <ol key="1" className="flex flex-col p-4 lg:p-0 lg:px-4 justify-start items-start gap-2 list-decimal">
                    {
                        bookingProcedure.map((bullet, index) => (
                            <li key={index} className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal ">{bullet}</li>
                        ))
                    }
                </ol>
            ]
        ]
    }
    return (
        <div className='grid grid-cols-1 lg:grid-cols-[30%_70%] gap-8 my-8'>
            <div className="flex flex-col items-center gap-5">
                <img src={sport.img} alt="photo" className="w-full h-[30rem] object-cover rounded-2xl" />
                <span className="text-blue-700 w-auto  text-justify text-sm font-bold  ">{sport.description}</span>
            </div>
            <div className="grid grid-cols-1">
                <ResponsiveTable headers={table1.header} contents={table1.content} />
                <ResponsiveTable headers={table2.header} contents={table2.content} />
            </div>
        </div>
    )
}

export default FacilitiesClub